import type { ModuleDefinition } from "../types";
import { AUDIT_READ, CLUBS_MANAGE, CLUBS_TEXT, INSTALLATION_VIEW } from "./permissions";

const screens = () => import("./screens");

export const adminModule: ModuleDefinition = {
  id: "admin",
  labelKey: "module.admin",
  // Users, roles and the audit log belong to core, which every license includes.
  licenseModule: "core",
  nav: [
    { id: "users", labelKey: "admin.nav.users", to: "/admin/users", icon: "users", permission: CLUBS_MANAGE },
    { id: "roles", labelKey: "admin.nav.roles", to: "/admin/roles", icon: "shield", permission: CLUBS_MANAGE },
    { id: "settings", labelKey: "admin.nav.settings", to: "/admin/settings", icon: "sliders", permission: CLUBS_MANAGE },
    { id: "communications", labelKey: "admin.nav.communications", to: "/admin/communications", icon: "share", permission: CLUBS_MANAGE },
    { id: "wording", labelKey: "admin.nav.wording", to: "/admin/wording", icon: "edit", permission: CLUBS_TEXT },
    { id: "audit", labelKey: "admin.nav.audit", to: "/admin/audit", icon: "log", permission: AUDIT_READ },
    { id: "installation", labelKey: "admin.nav.installation", to: "/admin/installation", icon: "key", permission: INSTALLATION_VIEW },
  ],
  routes: [
    { path: "admin", load: async () => ({ default: (await screens()).AdminIndexRedirect }) },
    { path: "admin/microsoft", permission: CLUBS_MANAGE, load: async () => ({ default: (await screens()).MicrosoftSettingsPage }) },
    { path: "admin/users", permission: CLUBS_MANAGE, load: async () => ({ default: (await screens()).UsersPage }) },
    { path: "admin/roles", permission: CLUBS_MANAGE, load: async () => ({ default: (await screens()).RolesPage }) },
    { path: "admin/settings", permission: CLUBS_MANAGE, load: async () => ({ default: (await screens()).ClubSettingsPage }) },
    { path: "admin/communications", permission: CLUBS_MANAGE, load: async () => ({ default: (await screens()).CommunicationsPage }) },
    { path: "admin/wording", permission: CLUBS_TEXT, load: async () => ({ default: (await screens()).WordingPage }) },
    { path: "admin/audit", permission: AUDIT_READ, load: async () => ({ default: (await screens()).AuditLogPage }) },
    { path: "admin/installation", permission: INSTALLATION_VIEW, load: async () => ({ default: (await screens()).InstallationPage }) },
  ],
};
